import { v4 as uuid } from 'uuid';
import { USER_DIALOG_ACTION_TYPES } from '../../constants/userDialog.constants';

export const showAddVehicleDialog = ({ requestId = uuid(), closeOnSave = true } = {}) => ({
  type: USER_DIALOG_ACTION_TYPES.SHOW_ADD_VEHICLE_DIALOG,
  payload: { requestId, closeOnSave },
});

export const hideAddVehicleDialog = (requestId) => ({
  type: USER_DIALOG_ACTION_TYPES.HIDE_ADD_VEHICLE_DIALOG,
  payload: { requestId },
});

export const vehicleDialogCreated = (vehicle, requestId) => ({
  type: USER_DIALOG_ACTION_TYPES.VEHICLE_DIALOG_CREATED,
  payload: { vehicle, requestId },
});
